import React, { useState } from 'react';
import axios from 'axios';
import './LoginPage.css'; // 👈 Import the CSS file

const LoginPage = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      setError('Email and password are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post('https://apiiq.jamamasjidquba.com/api/auth/login', {
        email,
        password,
      });

      if (response.data.success) {
        onLoginSuccess(); // 👈 Switches view in App.js
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h1>Zabiha Qurbani</h1>
      <input
        placeholder="Email"
        value={email}
        
        onChange={e => setEmail(e.target.value)}
      />
      <input
        placeholder="Password"
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
      <button onClick={handleLogin} disabled={loading}>
        {loading ? 'Logging in...' : 'Login'}
      </button>
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default LoginPage;
